<div class="mat-elevation-z8 table-host">
  <div class="table-scroll" #scrollHost>
    <table mat-table matSort [dataSource]="dataSource" class="this-table">
      @for (item of columnsValue; track item) {
        <ng-container [matColumnDef]="item">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="header-cell">
              <div>{{ item | titlecase }}</div>
              @if (checkFilterColumn(item)) {
                <input
                  [placeholder]="item"
                  class="search-input"
                  value=""
                  (keyup)="applyFilter($event, item)"
                />
              }
            </div>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element[getKeyBy(item)] }}
          </td>
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="columnsValue; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; index as i; columns: columnsValue"
        [style.background-color]="getSelected(i) ? '#3f51b5' : row.bg && '#' + row.bg"
        [style.color]="getSelected(i) ? '#fff' : row.fg && '#' + row.fg"
        (click)="onRowClick(row, i, $event)"
        (dblclick)="onRowDblClick(row, i, $event)"
      ></tr>
    </table>
  </div>
  @if (isPaginator) {
    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100, 200]" showFirstLastButtons></mat-paginator>
  }
</div>
